module.exports = __webpack_public_path__ + "static/pic01-4ee3b098fd62d110863ed47d7cabaf13.jpg";